import React from 'react';
import NavComponent from "./NavComponent";
import FooterComponent from "./FooterComponent";
import ListIdeasComponent from "./ListIdeasComponent";
import FooterComponentHome from "./FooterComponentHome";

function TableComponent() {
    return (
        <div>
            <div>
                <NavComponent />
                <ListIdeasComponent />
                <FooterComponentHome />
            </div>
        </div>
    );
}

export default TableComponent;